'use client'

import { TripDetailsModel } from '@/features/trips/types/models/trip-details.model'
import { useEffect, useRef } from 'react'
import { useOrderSummaryStore, useReservationStore } from '../../store'
import { OrderStep } from '../../types/enums/order-step.enum'

type Props = {
  trip: TripDetailsModel
}

export const InitUpdateTrip: React.FC<Props> = ({ trip }) => {
  const setOrderSummary = useOrderSummaryStore(state => state.setMany)
  const setTripToUpdate = useReservationStore(state => state.setTripToUpdate)
  const initialized = useRef(false)
  useEffect(() => {
    if (initialized.current) return
    initialized.current = true
    setOrderSummary({
      isUpdate: true,
      date: trip.date ? new Date(trip.date) : null,
      time: trip.time ? new Date(trip.time) : null,
      discount: Number(trip.discount) || 0,
      fullName: trip.userName || '',
      phoneNumber: '',
      email: '',
      step: OrderStep.TRIP_INFO,
      fromPointName: trip.fromPointName || '',
      toPointName: trip.toPointName || '',
      fromPointDetails: trip.fromPointDetails || '',
      toPointDetails: trip.toPointDetails || '',
      vehicleSizeName: trip.vehicleClass || trip.tripType || '',
      handLuggage: trip.handLuggage || 0,
      checkedLuggage: trip.checkedLuggage || 0,
      passengers: trip.passengers || 0,
      childSeats: trip.childSeats || 0,
      booster: trip.booster || 0,
      carrier: trip.carrier || 0,
      providerPrice: Number(trip.providerPrice) || 0,
      customerPrice: Number(trip.customerPrice) || 0,
      totalPrice: Number(trip.totalPrice) || 0,
      price: Number(trip.price) || 0,
      oldTotalPrice: Number(trip.totalPrice) || 0,
      currency: trip.currency || null,
    })
    setTripToUpdate(trip)
  }, [trip, setOrderSummary, setTripToUpdate])

  return null
}
